import { LE } from "@/constants/enumsNew";
import type { DisposalReport } from "@/views/disposalReport/disposalReport";
import { fillLookupValuesByPropertyNames } from "@modernary/mui/components/lookup";

export default {
  addAuthRequestFields,
  getInitialData,
  skinnyResponseAdapter,
  requestAdapter,
  responseAdapter,
};

function addAuthRequestFields(entity: DisposalReport) {
  entity._authRequestFields = [
    "id",
    "facilitySiteId",
    "statusMurn",
    "typeMurn",
    "year",
    "isReportStarted",
  ] as (keyof DisposalReport)[];
  return entity;
}

function getInitialData() {
  const result = {
    typeMurn: LE.ReportType.DisposalReport,
    statusMurn: LE.DisposalReportStatus.Scheduled,
    disposedWastes: [],
  } as unknown as DisposalReport;
  //TODO:TS
  return addAuthRequestFields(result);
}

const validNumberInputRegex = /^[0-9]\d{0,2}(\d{3})*(\.\d+)?$/;
const tonnageChangeHandler = (disposalReport: DisposalReport) => {
  const newTotal = disposalReport.disposedWastes.reduce(
    (prev, curr) =>
      curr.tonnage && validNumberInputRegex.test(curr.tonnage?.toString())
        ? prev + parseFloat(curr.tonnage?.toString())
        : prev,
    0,
  );

  disposalReport.totalTons = newTotal;
};

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: DisposalReport }) {
  addAuthRequestFields(response.data);

  return response.data;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: DisposalReport }) {
  await skinnyResponseAdapter(response);

  tonnageChangeHandler(response.data);
  await fillLookupValuesByPropertyNames(response.data, ["statusMurn", "typeMurn", "periodMurn"]);

  response.data.disposedWastes?.forEach((x) => {
    x.key = x.id;
  });

  return response.data;
}

function requestAdapter() {}
